import React from 'react';
import PropTypes from 'prop-types';
import cnames from 'classnames';

import { AspectRatioCard } from '@homeaway/react-aspect-ratio-card';
import { SHORT_CAROUSEL_ASPECT_RATIO, TALL_CAROUSEL_ASPECT_RATIO } from '../constants';
import './CarouselCard.less';


const CarouselCard = ({
  /** Url where the user will navigate to when clicking on the card*/
  clickUrl,
  /** Callback to be called when the user clicks on the card */
  onClick,
  /** Value to determine whether to use a short or a tall card */
  aspectRatio,
  /** Class to be added to the card anchor */
  className,
  ...otherProps
}) => (
  <a
    href={clickUrl}
    className={cnames('CarouselCard', { [className]: className })}
    onClick={onClick}
  >
    <AspectRatioCard
      aspectRatio={aspectRatio}
      {...otherProps}
    />
  </a>
);

CarouselCard.propTypes = {
  onClick: PropTypes.func,
  clickUrl: PropTypes.string.isRequired,
  aspectRatio: PropTypes.oneOf([TALL_CAROUSEL_ASPECT_RATIO, SHORT_CAROUSEL_ASPECT_RATIO]),
  className: PropTypes.string
};

CarouselCard.defaultProps = {
  onClick: () => {},
  className: '',
  aspectRatio: SHORT_CAROUSEL_ASPECT_RATIO
};

export default CarouselCard;



// WEBPACK FOOTER //
// ./src/universal/components/Carousel/CarouselCard/CarouselCard.js